/* eslint-disable default-case */
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { message } from 'antd';
import { Col, Hidden } from "react-awesome-styled-grid";
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import { DescriptionText, SubmitButton } from "../../../design";
import InputEmail from "./InputEmail";
import { useForm, useWatch } from "react-hook-form";
import InputPhone from "./InputPhone";
import InputFileUpload from "./InputFileUpload"
import PaymentPageSupport from "./PaymentPageSupport";
import CardIconList from "./CardIconList";
import SmallScreenView from "../../../components/smallscreen";
import ProductDetails from "./ProductDetails";
import Account from "./Account";
import InputFixedAmount from "./InputFixedAmount";
import InputQuantity from "./InputQuantity";
import InputAdjustableAmount from "./InputAdjustableAmount";
import InputNumber from "./InputNumber";
import InputAlpha from "./InputAlpha";
import InputAlphaNumeric from "./InputAlphaNumeric";
import InputPromotionCode from "./InputPromotionCode";
import InputSingleLineText from "./InputSingleLineText";
import InputLargeText from "./InputLargeText";
import ComboBox from './ComboBox';
import InputTip from "./InputTip";
import Waiver from "./Waiver";
import { h2FontSize, submitFontSize, submitHeight } from "../../../utils/reseponsive";
import currencyFormatter from "../../../utils/currencyformatter";
import { AmountDivideByHundred } from "../../../helper";
import { COUNTRY_PHONE_CODE } from "../../../appconstants";
import AsYouType from "libphonenumber-js";
import '../../../assets/css/survey.css';
import { axiosEmptyInstance, getPreSignedUrl, uploadFile } from '../../../api';

type Props = {
  paymentPageMeta: Object,
  onSubmit: Function,
  account: Object,
  phoneCode: String,
  isPreview: boolean,
  isAdaptive: boolean,
  gid: String,
  showTipError: Boolean,
  paymentHeading: String,
  showPromoError: Boolean,
  showHoursError: Boolean,
  showComboError: Boolean,
  showCustomMinMaxError: Boolean,
  getComboInfo: Function,
  updateWaiverDocs: Function,
  fileUploadError: Boolean,
  showCustomForm: Boolean,
  history: {
    push: Function,
  },
  id: String,
}

const PaymentPageDetails = (props: Props) => {
  const accGid = [
    "account-ff1166de992e429c82eb02f86dfdbbab",
    "account-ee13cf50fea3429db080b57385445247"
  ];
  const { paymentPageMeta, onSubmit, account, isPreview, phoneCode, paymentHeading, isAdaptive, showTipError, gid, showComboError, showPromoError, showHoursError, showCustomMinMaxError, getComboInfo, updateWaiverDocs, fileUploadError, showCustomForm, id } = props;
  const [paymentPageMetaFields, setPaymentPageMetaFields] = useState([]);
  const [customFormDetails, setCustomFormDetails] = useState([]);
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState(null);
  const [country, setCountry] = useState(null);
  const [submitBtnText, setSubmitBtnText] = useState("PAY NOW");
  const [hideCombobox, setHideComboBox] = useState(null);
  const comboID = accGid.includes(gid);
  const [exstingMemberMessage, setExstingMemberMessage] = useState('');
  const soldOut = (paymentPageMeta != null &&
    (paymentPageMeta.gid === 'paymentpagemeta-0bfe7010378a4cd7b95d0d6f7dd52aba' || paymentPageMeta.gid === 'paymentpagemeta-73d3c3b9e4034c9c92290dc808a15b85'))
    ? true : (paymentPageMeta != null && (paymentPageMeta.status === 'SOLD_OUT'))
      ? true : false;
  const {
    control,
    handleSubmit,
    errors,
    setValue,
    getValues,
  } = useForm();

  const watch = useWatch({ control });
  const [comboFinalData, setComboFinalData] = useState({});


  useEffect(() => {
    setPaymentPageMetaFields(paymentPageMeta && paymentPageMeta.paymentPageMetaFields);
    setCustomFormDetails(paymentPageMeta?.formMeta?.formData);
  }, [paymentPageMeta, hideCombobox]);


  useEffect(() => {
    generateData();
  }, [watch]);

  const callCombo = (list, id) => {
    comboFinalData[`${id}`] = list;
    setComboFinalData(comboFinalData);
    getComboInfo(list, id);
    generateData();
  }

  const generateData = () => {
    const data = getValues();
    let initAmount = 0;
    let localCurrency = null;

    const paymentPageMetaFieldTypes = ["PRICE_AMOUNT_FIXED", "PRICE_AMOUNT_CUSTOMER_DECIDED", "PRICE_AMOUNT_QUANTITY_BASED"];
    paymentPageMeta && paymentPageMeta.paymentPageMetaFields && paymentPageMeta.paymentPageMetaFields.map(meta => {
      let amount = 0;
      let quantity = 0;

      if (paymentPageMetaFieldTypes.includes(meta.type) && meta.currency && !localCurrency) {
        localCurrency = meta.currency;
      }
      if (meta.type === 'PRICE_AMOUNT_QUANTITY_BASED') {
        amount = meta.amount;
        quantity = parseInt(data[meta.gid]);
        if (amount && quantity)
          initAmount += parseFloat(amount * quantity);
      }
      if (meta.type === 'PRICE_AMOUNT_CUSTOMER_DECIDED') {
        amount = (data[meta.gid] && parseFloat(data[meta.gid]) * 100);
        if (amount) {
          initAmount += parseFloat(amount);
        }
      }
      if (meta.type === 'PRICE_AMOUNT_FIXED' && data[meta.gid]) {
        amount = meta.amount;
        if (amount)
          initAmount += parseFloat(amount);
      }
    });
    const myComboData = Object.keys(comboFinalData).map(key => {
      return comboFinalData[key];
    });
    let comboAmount = 0;
    for (let i = 0; i < myComboData.length; i += 1) {
      for (let j = 0; j < myComboData[i].length; j += 1) {
        comboAmount += myComboData[i][j].price ? myComboData[i][j].price : 0;
      }
    }
    setAmount(initAmount);
    setCurrency(localCurrency);

    setSubmitBtnText(initAmount && localCurrency ? `PAY NOW ${currencyFormatter(AmountDivideByHundred((comboAmount ? comboAmount : 0) + initAmount), localCurrency && localCurrency.name)}` : "PAY NOW");
  };

  const fileReader = async file => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsArrayBuffer(file.value);
  });

  const fileUpload = async (info) => {

    const formData = new FormData();
    formData.append(info.name, info);
    try {
      const keyType = "PAYMENT_PAGE_DOCUMENT";
      const value = await getPreSignedUrl();
      await axiosEmptyInstance.put(value, { headers: { 'Content-Type': info.type } });

      const { fileUrl } = await uploadFile(value, keyType);
      console.log(fileUrl);
      return fileUrl;
    } catch (e) {
      console.error("File upload error:", e);
      message.error("File upload failed. Please try again.");
    }
  };

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const surveyJson = {
    pages: paymentPageMeta?.formMeta?.formData ? paymentPageMeta?.formMeta?.formData : [],
  };

  const survey = new Model(surveyJson);

  survey.onValueChanged.add(async function (sender, options) {
    const updateData = JSON.parse(localStorage.getItem(id));
    const tempFormData = updateData?.paymentPageEntries;
    const key = Object.keys(sender.data);
    const paymentMetaArray = [];
    if (customFormDetails?.length > 0) {
      for (let i = 0; i < customFormDetails.length; i += 1) {
        if (customFormDetails[i]?.elements?.length > 0) {
          let tempObj = {};
          for (let j = 0; j < customFormDetails[i]?.elements.length; j += 1) {
            tempObj = customFormDetails[i]?.elements[j];
            paymentMetaArray.push(tempObj);
            tempObj = {};
          }
        }
      }
    }
    for (let i = 0; i < tempFormData?.length; i += 1) {
      for (let k = 0; k < key.length; k += 1) {
        if (updateData?.paymentPageEntries[i]?.label === key[k]) {
          const index = paymentMetaArray.findIndex((item) => item.name === key[k]);
          const tempVal = sender.data[key[k]];
          if (paymentMetaArray[index].type === "file") {
            tempFormData[i].dataType = 'image';
            tempFormData[i].formInputData = { imageUrl: await fileUpload(tempVal) };
          } else if (paymentMetaArray[index].type === "imagepicker") {
            tempFormData[i].dataType = 'image';
            tempFormData[i].formInputData = { imageUrl: await fileUpload(tempVal) };
          } else if (paymentMetaArray[index].type !== "file" && paymentMetaArray[index].type !== "imagepicker") {
            if (typeof tempVal === 'string') {
              tempFormData[i].value = tempVal;
            }
            if (typeof tempVal === 'number') {
              tempFormData[i].value = tempVal;
            }
            if (typeof tempVal !== 'number' && typeof tempVal !== 'string') {
              tempFormData[i].formInputData = tempVal;
            }
            tempFormData[i].dataType = typeof tempVal;
          }
          tempFormData[i].label = paymentMetaArray[index].title || tempFormData[i].label;
        }
      }
    }
    updateData.paymentPageEntries = tempFormData;
    localStorage.setItem(id, JSON.stringify(updateData));
  });

  survey.onComplete.add((sender, options) => {
    props.history.push(props.history.location && props.history.location.pathname + '/pay');
    // You can send sender.data to your backend here
  });

  const comboHide = (val) => {
    setHideComboBox(val)
  };

  const callOptions = (val) => {
    const list = [...paymentPageMetaFields];
    const index = list.findIndex(p => p.gid === val.gid);
    list[index] = val;
    setPaymentPageMetaFields(list);
  }

  const callMember = (val) => {
    const list = [...paymentPageMetaFields];
    const index = list.findIndex(p => p.gid === val.gid);
    list[index] = val;
    setPaymentPageMetaFields(list);
  }

  const batmAccntGid = [
    "account-34e748e74b5445709d6d53592f14d3d4",
  ];

  const isExsingUserCheck = async (userEmail) => {
    if (batmAccntGid.includes(account.gid)) {
      const payload = {
        email: userEmail,
      };
      try {
        const { data: { body } } = await axios.post('https://1zo8wm1ejf.execute-api.ap-south-1.amazonaws.com/default/batm-membership-check', payload);
        const userData = JSON.parse(body)
        setExstingMemberMessage(userData?.message);
      } catch (e) {
        console.error(e);
      }
    }
  }

  const getPaymentComponent = (data, index) => {
    const name = data.gid || index;
    const email = paymentPageMeta && paymentPageMeta.contactUsEmail;
    const phoneNum = paymentPageMeta && paymentPageMeta.contactUsPhone && AsYouType(paymentPageMeta.contactUsPhone);
    const phone = phoneNum && phoneNum.nationalNumber || "";
    const countryCode = phoneNum && `+${phoneNum.countryCallingCode}`;
    const countryCallingCode = countryCode && findCountryCallingCode(countryCode) || ""
    switch (data.type) {
      case "CONSENT_FORM":
        return <Waiver data={data} index={index} updateWaiverDocs={updateWaiverDocs} />;
      case "INPUT_EMAIL":
        return <InputEmail
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          isRequired={data.isRequired} label={data.label}
          description={data.description}
          isExsingUserCheck={isExsingUserCheck}
          name={`${name}`} email={email} />;
      case "INPUT_PHONE":
        return <InputPhone
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          countryCallingCode={phoneCode}
          name={`${name}`} phone={phone} />;
      case "INPUT_NUMBER":
        return <InputNumber
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case "INPUT_ALPHA":
        return <InputAlpha
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case "INPUT_ALPHA_NUMERIC":
        return <InputAlphaNumeric
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          selectedAccount={account && account}
          data={data}
          callMember={callMember}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case "PROMOTIONAL_CODES":
        return <InputPromotionCode
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case "INPUT_SINGLE_LINE_TEXT":
        return <InputSingleLineText
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case "INPUT_LARGE_TEXT":
        return <InputLargeText
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          selectedAccount={account && account}
          callOptions={callOptions}
          data={data}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case "PRICE_AMOUNT_FIXED":
        return <InputFixedAmount label={data.label} setValue={setValue}
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors} description={data.description} isRequired={data.isRequired}
          name={`${name}`}
          options={data.comboBox}
          isComboBoxRequired={data.isComboBoxRequired}
          amount={data.amount} currencyName={data.currency && data.currency.name} />;
      case "PRICE_AMOUNT_CUSTOMER_DECIDED":
        return <InputAdjustableAmount label={data.label}
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors} description={data.description} isRequired={data.isRequired}
          name={`${name}`}
          amount={data.amount} currencyPrefix={data.currency && data.currency.prefix} maxAmount={data.maxPrice} minAmount={data.minPrice} />;
      case "PRICE_AMOUNT_QUANTITY_BASED":
        return <InputQuantity label={data.label} setValue={setValue}
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors} description={data.description}
          isRequired={data.isRequired} name={`${name}`}
          comboHide={comboHide}
          selectedAccount={account && account}
          options={data.comboBox || []}
          callCombo={callCombo}
          id={data.gid}
          countryCallingCode={phoneCode}
          showComboError={showComboError}
          isComboBoxRequired={data.isComboBoxRequired}
          amount={data.amount} currencyName={data.currency && data.currency.name}
          maxQty={data.quantityMaxLimit} minQty={data.quantityMinLimit} />;
      case "REFERENCE_NUMBER":
        return <InputAlphaNumeric
          isPreview={isPreview} isAdaptive={isAdaptive}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          name={`${name}`} />;
      case 'COMBO_BOX':
        return <ComboBox
          isPreview={isPreview}
          isAdaptive={isAdaptive}
          control={control}
          errors={errors}
          label={data.label}
          description={data.description}
          isRequired={data.isRequired}
          options={data.comboBox}
          name={`${name}`}
          setValue={setValue}
          selectedAccount={account && account}
          hideCombobox={(hideCombobox === true) ? true : (hideCombobox === false) ? false : comboID}
        />;
      case "TIP":
        return <InputTip
          isPreview={isPreview} isAdaptive={isAdaptive} setValue={setValue}
          control={control} errors={errors} tipPercentages={data.tipPercentages}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          showTipError={showTipError}
          name={`${name}`} />;
      case "FILE_UPLOAD":
        return <InputFileUpload
          isPreview={isPreview} isAdaptive={isAdaptive}
          fileUploadError={fileUploadError}
          control={control} errors={errors}
          label={data.label} description={data.description}
          isRequired={data.isRequired}
          quantityMaxLimit={data.quantityMaxLimit}
          quantityMinLimit={data.quantityMinLimit}
          setValue={setValue}
          name={`${name}`} />;
    }
  };

  return (
    <div id="payment-page">
      {
        soldOut ?
          <div class="sold_out">Sold out</div> : null
      }
      <Col md={showCustomForm ? 0 : 3} sm={8} lg={showCustomForm ? 0 : 3} className="mt-md-5 mb-2 p-4 payment-page-right" style={{ boxShadow : showCustomForm ? 'none' : '' }}>
        <SmallScreenView>
          {account && <Account primaryColor={paymentPageMeta && paymentPageMeta.primaryColor} isPreview={isPreview} isAdaptive={isAdaptive} name={account.name} logo={account.largeLogo} />}
          {
            showCustomForm ? (
              <Survey model={survey} />
            ) : (
              <>
                {paymentPageMeta && <ProductDetails
                  isPreview={isPreview}
                  isAdaptive={isAdaptive}
                  primaryColor={paymentPageMeta && paymentPageMeta.primaryColor}
                  content={paymentPageMeta.content}
                  imageUrl={paymentPageMeta.logo}
                  title={paymentPageMeta.title}
                  venueAddress={paymentPageMeta.venueAddress}
                  coordinate={paymentPageMeta.coordinate}
                  ytVideoId={paymentPageMeta.ytVideoId}
                  ytVideoDescription={paymentPageMeta.ytVideoDescription}
                  ytVideoHeading={paymentPageMeta.ytVideoHeading}
                  gid={gid}
                />}
              </>
            )
          }
        </SmallScreenView>
        {
          showCustomForm ? (
            <></>
          ) : (
            <>
              <div className="pt-3 s">
                <DescriptionText fontSize={h2FontSize(isPreview, isAdaptive)} color="#474747">{paymentHeading ? paymentHeading : gid ? 'PLACE ORDER' : 'PAYMENT DETAILS'}</DescriptionText>
              </div>
              <form onSubmit={(e) => { e.preventDefault(); handleSubmit(onSubmit)(e); }}>
                <div className="payment-page-form-elements py-2 pr-2">
                  {
                    phoneCode && paymentPageMetaFields && paymentPageMetaFields.sort((a, b) => a.sequenceNumber > b.sequenceNumber ? 1 : -1).map((value, index) =>
                      <div className="mt-3" key={index}>
                        {getPaymentComponent(value, index)}
                      </div>
                    )
                  }
                </div>
                {
                  paymentPageMeta && (
                    <div className="pt-4 text-center">
                      {
                        showPromoError ? (
                          <p style={{
                            fontSize: '14px',
                            color: '#ff1e1e',
                            fontWeight: '500',
                            marginBottom: '20px',
                          }}>Invalid Promocode</p>
                        ) : (
                          <></>
                        )
                      }
                      {
                        showHoursError ? (
                          <p style={{
                            fontSize: '14px',
                            color: '#ff1e1e',
                            fontWeight: '500',
                            marginBottom: '20px',
                          }}>Merchant is not available to take the order</p>
                        ) : (
                          <></>
                        )
                      }
                      {
                        showComboError ? (
                          <p style={{
                            fontSize: '14px',
                            color: '#ff1e1e',
                            fontWeight: '500',
                            marginBottom: '20px',
                          }}>Please select the combofield</p>
                        ) : (
                          <></>
                        )
                      }
                      {
                        showCustomMinMaxError ? (
                          <p style={{
                            fontSize: '14px',
                            color: '#ff1e1e',
                            fontWeight: '500',
                            marginBottom: '20px',
                          }}>Total 10 tickets must be purchased. The tickets can be either for Adult or Children (above 3 years).</p>
                        ) : (
                          <></>
                        )
                      }
                      {
                        exstingMemberMessage ? (
                          <p style={{
                            fontSize: '14px',
                            color: '#1b5e20',
                            fontWeight: '500',
                            marginBottom: '20px',
                          }}>{exstingMemberMessage}</p>
                        ) : (
                          <></>
                        )
                      }
                      {
                        (amount <= 0) ? (
                          <SubmitButton
                            disabled
                            backgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                            hoverBackgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                            height={submitHeight(42, isAdaptive)}
                            className="m-0"
                            fontSize={submitFontSize(isAdaptive)}
                            type="submit"
                          >
                            {soldOut ? 'Sold Out' : submitBtnText}
                          </SubmitButton>
                        ) : (
                          <SubmitButton
                            backgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                            hoverBackgroundColor={paymentPageMeta && paymentPageMeta.primaryColor ? paymentPageMeta.primaryColor : '#40A9FF'}
                            disabled={soldOut ? true : isPreview}
                            height={submitHeight(42, isPreview, isAdaptive)}
                            className="m-0"
                            fontSize={submitFontSize(isPreview, isAdaptive)}
                            type="submit"
                          >
                            {soldOut ? 'Sold Out' : submitBtnText}
                          </SubmitButton>
                        )
                      }
                      <CardIconList country={currency} />
                    </div>
                  )
                }
              </form>
            </>
          )
        }
        <SmallScreenView>
          {paymentPageMeta && account && <PaymentPageSupport
            primaryColor={paymentPageMeta && paymentPageMeta.primaryColor}
            email={paymentPageMeta.contactUsEmail}
            termsAndCondition={paymentPageMeta.termsAndConditions}
            phone={paymentPageMeta.contactUsPhone}
            isPreview={isPreview}
            isAdaptive={isAdaptive}
            selectedAccount={account && account}
            showCustomForm={showCustomForm}
          />}
        </SmallScreenView>
      </Col>
      <Hidden xs sm>
        <Col md={showCustomForm ? 9 : 6} className="p-4 bg-white" style={{ boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.1)", borderRadius: "10px", minHeight: "100%", height: "100%", overflow: "hidden auto" }}>
          <div className={showCustomForm ? "p-3 col-12 col-lg-12" : "p-3 col-12 col-lg-9"} style={{ minHeight: "100%" }}>
            {account && <Account primaryColor={paymentPageMeta && paymentPageMeta.primaryColor} isPreview={isPreview} isAdaptive={isAdaptive} name={account.name} logo={account.largeLogo} />}
            {
              showCustomForm ? (
                <Survey model={survey} />
              ) : (
                <>
                  {paymentPageMeta && <ProductDetails
                    isPreview={isPreview}
                    isAdaptive={isAdaptive}
                    content={paymentPageMeta.content}
                    imageUrl={paymentPageMeta.logo}
                    title={paymentPageMeta.title}
                    primaryColor={paymentPageMeta && paymentPageMeta.primaryColor}
                    venueAddress={paymentPageMeta.venueAddress}
                    coordinate={paymentPageMeta.coordinate}
                    ytVideoId={paymentPageMeta.ytVideoId}
                    ytVideoDescription={paymentPageMeta.ytVideoDescription}
                    ytVideoHeading={paymentPageMeta.ytVideoHeading}
                  />}
                </>
              )
            }

            {paymentPageMeta && <PaymentPageSupport isPreview={isPreview} isAdaptive={isAdaptive}
              email={paymentPageMeta.contactUsEmail}
              phone={paymentPageMeta.contactUsPhone}
              termsAndCondition={paymentPageMeta.termsAndConditions}
              primaryColor={paymentPageMeta && paymentPageMeta.primaryColor}
              agregatorName={account && account.aggregatorName}
              selectedAccount={account && account}
              showCustomForm={showCustomForm}
            />}
          </div>
        </Col>
      </Hidden>
    </div>
  )
};

export default PaymentPageDetails
